import { OrderType } from '../enums/OrderType';
import { PreorderType } from '../enums/PreorderType';

export class Tip {
	orderType: OrderType;
	subOrderTypes: PreorderType[]; // f.e. preOrder or preOrder.delivery or terminal
	enabled: boolean;
	defaultTips: DefaultTip[];
}

export interface DefaultTip {
	value: {
		$numberDecimal: number;
	}; // positive number (2 decimal places)
	type: TipsEnum;
}
export enum TipsEnum {
	ABSOLUTE = 'absolute',
	RELATIVE = 'relative',
	ANY = 'any',
}
